import { useState } from "react";
import { toast } from "sonner";
import { Loader2, PlusCircle } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { STATUSES } from "@/lib/statuses";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const EventForm = ({ shipment, onUpdated }) => {
  const blank = { status: shipment.status, location: "", description: "", public_note: "", when: "" };
  const [f, setF] = useState(blank);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const payload = { status: f.status, location: f.location, description: f.description, public_note: f.public_note };
      if (f.when) payload.timestamp = new Date(f.when).toISOString();
      const { data } = await api.post(`/admin/shipments/${shipment.code}/events`, payload);
      toast.success("Evento registrato: il tracking pubblico è aggiornato");
      setF({ ...blank, status: data.status });
      onUpdated(data);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="bg-white border border-slate-200 p-5 sm:p-6 space-y-4" data-testid="event-form">
      <h3 className="font-display text-lg font-bold uppercase">Aggiorna stato / aggiungi evento</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="sm:col-span-2">
          <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Stato *</Label>
          <Select value={f.status} onValueChange={(v) => setF({ ...f, status: v })}>
            <SelectTrigger className="mt-1.5 rounded-none" data-testid="event-status-select"><SelectValue /></SelectTrigger>
            <SelectContent>{STATUSES.map((s, i) => <SelectItem key={s.key} value={s.key} data-testid={`event-status-option-${s.key}`}>{i + 1}. {s.label}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <div>
          <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Località</Label>
          <Input value={f.location} onChange={set("location")} placeholder="Es. Bari" className="mt-1.5 rounded-none" data-testid="event-location-input" />
        </div>
        <div>
          <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Data e ora evento</Label>
          <Input type="datetime-local" value={f.when} onChange={set("when")} className="mt-1.5 rounded-none" data-testid="event-datetime-input" />
          <p className="mt-1 text-[11px] text-slate-400">Lascia vuoto per usare data e ora attuali.</p>
        </div>
        <div className="sm:col-span-2">
          <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Descrizione</Label>
          <Input value={f.description} onChange={set("description")} placeholder="Se vuota viene usato il nome dello stato" className="mt-1.5 rounded-none" data-testid="event-description-input" />
        </div>
        <div className="sm:col-span-2">
          <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Nota pubblica (visibile al cliente)</Label>
          <Textarea rows={2} value={f.public_note} onChange={set("public_note")} className="mt-1.5 rounded-none" data-testid="event-public-note-input" />
        </div>
      </div>
      <Button type="submit" disabled={busy} className="rounded-none bg-[#E50914] hover:bg-[#C10710]" data-testid="event-submit-btn">
        {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <PlusCircle className="h-4 w-4 mr-2" />} Registra evento
      </Button>
    </form>
  );
};
